import Alert, { alertClasses } from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { darken, lighten } from '@mui/material/styles';
import { svgIconClasses } from '@mui/material/SvgIcon';
import { makeStyles } from 'tss-react/mui';

import {
  ScaffolderFormPaper,
  ScaffolderInputHeader,
} from '../../../components';

const ALLOWLIST_DOC_URL =
  'https://github.com/tomtom-internal/deployment-as-a-service/blob/main/docs/tools/allowlist.md';

// An Alert is a Paper, so v4's `.MuiPaper-root` rule (shared class name, loaded
// after the v6 styles) paints it white; `&&` restores MUI's own info colours.
// The icon also needs `!important` to beat the app stylesheet's neutral grey
// for every info icon.
const useStyles = makeStyles()(theme => {
  const isLight = theme.palette.mode === 'light';
  return {
    alert: {
      '&&': {
        backgroundColor: (isLight ? lighten : darken)(
          theme.palette.info.light,
          0.9,
        ),
        color: (isLight ? darken : lighten)(theme.palette.info.light, 0.6),
        [`& .${alertClasses.icon} .${svgIconClasses.root}`]: {
          color: `${theme.palette.info.main} !important`,
        },
      },
    },
  };
});

export const ProjectAllowedReposNotice = () => {
  const { classes } = useStyles();

  return (
    <Box>
      <ScaffolderFormPaper>
        <ScaffolderInputHeader
          title="Allowed Repositories"
          variant="h5"
          divider
        />
        <Alert severity="info" className={classes.alert}>
          Project repository URL allowlists are now centrally managed. You can
          use any repository whose URL matches one of the{' '}
          <Link href={ALLOWLIST_DOC_URL} target="_blank" rel="noreferrer">
            allowed URL prefixes
          </Link>
          .
        </Alert>
      </ScaffolderFormPaper>
    </Box>
  );
};
